import { createAction, props } from "@ngrx/store";
import { IOrder, IOrderFilterRequest, IOrdersFilter, IOrdersKPIs } from "../models/order.model";
import { APIResponse } from "src/app/core/models/api-response";
import { IPageCount } from "src/app/shared/models/page.model";

// get orders
export const GetOrders = createAction(
  '[ AskFororder ] - GetOrders',
  props<{
    page: IPageCount;
    filter?: IOrderFilterRequest | undefined
    key?: string | undefined
    sort_by?: string;
    sort_mode?: string
  }>()
);
export const GetOrdersSuccess = createAction(
  '[ AskFororder ] - GetOrders Success ',
  props<{ res: APIResponse<IOrdersKPIs> }>()
);
export const GetOrdersError = createAction(
  '[ AskFororder ] - GetOrders Error',
);

// looder actions
export const SetOrdersLoader = createAction(
  '[ Tags ] - SetLoading',
  props<{ isLoading: boolean }>()
);

export const SetSearchOrdersLoader = createAction(
  '[ Loader ] - SearchLoader',
  props<{ isLoading: boolean }>()
);

// Filters
export const SetOrdersFilter = createAction(
  '[ Filters ] - SetordersFilter',
  props<{ keyword: string, advanced: IOrdersFilter | null }>()
);

// search
export const SetOrdersSearch = createAction(
  '[ Search ] - SetOrdersSearch',
  props<{ search: string }>()
);

// processing visibility
export const ToggleProcessingVisibility = createAction(
  '[ Orders ] - ToggleProcessingVisibility'
);
export const SetProcessingVisibility = createAction(
  '[ Orders ] - SetProcessingVisibility',
  props<{ visible: boolean }>()
);
export const RefreshOrders = createAction(
  '[ Orders ] - RefreshOrders'
);

// export
export const exportOrders = createAction(
  '[Order] Export Orders',
  props<{filter?: IOrderFilterRequest | undefined; key?: string | undefined;}>()
);
export const exportOrdersSuccess = createAction(
  '[Order] Export Orders Success',
  props<{ file: Blob }>()
);
export const exportOrdersFailure = createAction(
  '[Order] Export Orders Failure',
  props<{ error: any }>()
);
